// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});


export function highlight1(event) {
	Promise.all([$w('#vectorImage59').hide(), $w('#vectorImage60').show()]);
}

export function unhighlight1(event) {
	Promise.all([$w('#vectorImage59').show(), $w('#vectorImage60').hide()]); 
}

export function highlight2(event) {
	Promise.all([$w('#vectorImage61').hide(), $w('#vectorImage62').show()]); 
}

export function unhighlight2(event) {
	Promise.all([$w('#vectorImage61').show(), $w('#vectorImage62').hide()]); 
}

export function highlight3(event) {
	Promise.all([$w('#vectorImage63').hide(), $w('#vectorImage64').show()]);
}

export function unhighlight3(event) {
	Promise.all([$w('#vectorImage63').show(), $w('#vectorImage64').hide()]); 
}